<template>
  <div class="crew-detail">
    <div class="topImg">
      <img :src="list.picture" class="crewImg">
      <div class="crew-name">
        <p>{{list.movie_name}}</p>
      </div>
    </div>
    <div class="crew-info">
      <div class="top">
        <span class="first">基本信息</span>
      </div>
      <div class="info-list">
        <div class="info-p"><span class="info-title">作品名称</span>
          <div class="info-value"><span>{{list.movie_name}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">作品类型</span>
          <div class="info-value"><span>{{list.theme}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">出品方</span>
          <div class="info-value"><span>{{list.make}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">筹备地点</span>
          <div class="info-value"><span>{{list.prepare}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">开机时间</span>
          <div class="info-value"><span>{{list.start_time}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">暂定拍摄地点</span>
          <div class="info-value"><span>{{list.take_place}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">暂定拍摄周期</span>
          <div class="info-value"><span>{{list.take_period}}</span></div>
        </div>
        <div class="info-p"><span class="info-title">作品简介</span>
          <div class="info-value"><span>{{list.synopsis}}</span></div>
        </div>
      </div>
      <div class="staff-body">
        <ul class="staff-content">
          <li v-for="item in list.crew_post.slice(0,4)" :key="item.key">
            <div class="group-img-wrapper">
              <img :src="item.images_url" class="group-img">
            </div>
            <div class="staff-info">
              <p>{{item.position}}：{{item.name}}</p>
              <p>代表作：{{item.representative}}</p>
            </div>
          </li>
        </ul>

      </div>

    </div>
    <div class="recruit normal">
      <div class="top">
        <span class="first">招募类型</span>
      </div>
      <div class="recruit-content" v-for="(item,key) in list.crew_recruit" :key="item.key">
        <div class="group-info-wrapper">
          <div class="groupNum">
            {{key+1}}
          </div>
          <div class="p-info">
            <p class="p-title">{{item.nature}}：{{item.role_name}}</p>
            <p class="p-content">人物简介：{{item.synopsis}}</p>
          </div>
        </div>
        <div class="line"></div>


      </div>
      <div v-if="isNull" class="null-wrapper">
        <p class="null-info">--暂无--</p>
      </div>
    </div>
    <div class="content normal">
      <div class="top">
        <span class="first">联系方式</span>
      </div>
      <div v-for="(item, index) in list.crew_contact" :key="index">
      <div class="content-info">
        <p class="content_wrapper"><span class="c-title">姓名</span>：{{item.name}}</p>
        <p class="content_wrapper"><span class="c-title">手机号</span>：{{item.mobile}}</p>
        <p class="content_wrapper"><span class="c-title">qq号</span>：{{item.qqnumber}}</p>
        <p class="content_wrapper"><span class="c-title">微信号</span>：{{item.wechat}}</p>
        <p class="content_wrapper"><span class="c-title">邮箱</span>：{{item.mail}}</p>
      </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "Group",
    data() {
      return {
        list: [],
        isNull: false
      }
    },
    metaInfo() {
      return {
        title: this.list.movie_name || '',
        meta: [{
          name: 'keywords',
          content: ''
        },
          {
            name: 'description',
            content: ''
          }]
      }
    },
    methods: {
      getGroupData() {
        var api = `https://api.yopoo.cn/api/v1/crewminute?id=${this.$route.params.id}`
        this.$http.get(api).then((res) => {
            this.list = res.data
            if (res.data.crew_recruit.length == 0) {
              this.isNull = true
            }
          },
          err => {
            console.log(err)
          }
        )
      },
    },
    beforeMount() {
      this.getGroupData()
    }
  }
</script>

<style scoped>
  .c-title{
  }
  .content-info{
    font-size: .32rem;
    margin-left: .23rem;
  }
  .content_wrapper{
    display: flex;
  }
  .null-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: .2rem;
  }

  .null-info {
    font-size: .3rem;
    font-weight: lighter;

  }

  .normal {
    background: #fff;
    margin-top: .20rem;

  }

  .top {
    /*padding: .1rem 0;*/
  }

  .crew-info {
    background: #fff;
  }

  .topImg {
    position: relative;
  }

  .crewImg {
    width: 100%;
    height: auto;
  }

  .crew-name {
    position: absolute;
    height: 8%;
    top: 92%;
    left: 0;
    right: 0;
    bottom: 0;
    color: #fff;
    background: rgba(0, 0, 0, .5);
  }

  .crew-name > p {
    font-size: .3rem; /*rem*/
    font-weight: 400;
    padding-top: .15rem;
    padding-left: .23rem;
  }

  .first {
    padding-left: .23rem;
    font-weight: bold;
    font-size: .32rem;
  }

  .info-p {
    display: flex;
    padding-left: .23rem;
    padding-top: .20rem;
  }

  .info-title {
    white-space: nowrap;
    width: .63rem;
    font-size: .3rem; /*rem*/
    font-weight: normal;
  }

  .info-value {
    font-size: .3rem; /*rem*/
    margin-left: 1.60rem;
    color: #666;

  }

  .staff-content {
    display: flex;
    justify-content: space-around;
  }

  .group-img-wrapper {

  }

  .group-img {
    width: 1.65rem;
    height: 2.20rem;
  }

  .staff-body {
    margin: .20rem .23rem;
    padding-bottom: .40rem;
  }

  .group-info-wrapper {
    display: flex;
  }

  .groupNum {
    height: .46rem;
    width: .46rem;
    background: rgba(200, 185, 166, 1);
    margin: .23rem;
    font-size: .20rem; /*rem*/
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .p-info {
    flex: 1;
    margin-top: .15rem;
    margin-bottom: .23rem;
    width: .642rem;
    margin-right: .23rem;
  }

  .line {
    height: .01rem;
    background: #D9D9D9;
    margin: 0 .23rem;
  }

  .staff-info {
    font-size: .21rem;
  }

  .p-title {
    font-size: .3rem;
    font-weight: bolder;
  }

  .p-content {
    font-size: .29rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Group.vue